module.exports = __webpack_public_path__ + "html/user-settings.template.html";